import React from 'react';
import { IAction } from './newRoleReducer';
import { Permission } from 'entities/user';
import { ISelectMultiOption } from '@salecycle/ui-component-library';

export interface IState {
  currentStep: number;
  description: string;
  name: string;
  permissions: { [key in Permission]: boolean };
  users: ISelectMultiOption<string>[];
  validSteps: number[];
}

export const defaultContextValues: IState = {
  currentStep: 0,
  description: '',
  name: '',
  permissions: {
    Debug: false,
    ManageAssets: false,
    ManageCampaigns: false,
    ManageClients: false,
    ManageDispatchers: false,
    ManageEnrichments: false,
    ManageThirdPartyConsent: false,
    ManageFiles: false,
    ManageLinks: false,
    ManageSftpUsers: false,
    ManageTemplates: false,
    ManageTrends: false,
    ManageUnsubscribes: false,
    ManageUsers: false,
    ManageVoucherCodes: false,
    ViewAll: false,
    ViewDashboards: true,
  },
  users: [],
  validSteps: [],
};

export type Dispatch = (action: IAction) => void;

export const NewRoleStateContext = React.createContext<IState | undefined>(undefined);
export const NewRoleDispatchContext = React.createContext<Dispatch | undefined>(undefined);

export function useNewRoleState() {
  const context = React.useContext(NewRoleStateContext);

  if (!context) {
    throw new Error('useNewRoleStateContext must be used within a NewRoleProvider');
  }

  return context;
}

export function useNewRoleDispatch() {
  const context = React.useContext(NewRoleDispatchContext);

  if (!context) {
    throw new Error('useNewRoleDispatch must be used within a NewRoleProvider');
  }

  return context;
}
